import src from "IMAGE";
export default { src, width: 1080, height: 1080, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAPklEQVR42r2KywpAERQAz+O6C8lCiUjIwv//IdmylKlZzQDcBRGXx8b8qRSqdNYj0T6xEL9ppescyxwI3jEA6UMByL+30osAAAAASUVORK5CYII="};
